import React from 'react';

import { Recommendation } from 'app/types/entities';
import { useCompareContext } from 'Contexts/compareContext';
import { useTextContext } from 'Contexts/textContext';
import { Button } from 'DesignLibrary/atoms/Button';
import Plan from 'Models/plan';
import Text from 'Shared/Text';

import { CompareTableRow } from '../_shared/CompareTableRow';

export interface ChooseButtonsProps {
  selectedPlan: Plan | Record<string, never>;
  reviewModePlans: Plan[];
  choosePlan: (plan: Recommendation) => void;
  deselectPlan: () => void;
  hideAsterikIfCompareDrawer?: boolean;
}

export const ChooseButtons = ({
  selectedPlan,
  reviewModePlans,
  choosePlan,
  deselectPlan,
  hideAsterikIfCompareDrawer = false,
}: ChooseButtonsProps) => {
  const { comparablePlans } = useCompareContext();
  const { retrieveContentfulData } = useTextContext();
  const plans = comparablePlans.length > 0 ? comparablePlans : reviewModePlans;

  const renderChooseButton = (plan: Plan) => {
    const isSelected = selectedPlan.planId && selectedPlan.planId === plan.planId;
    const buttonLabelField = isSelected
      ? 'health_section.button_text.selectedPlan'
      : 'health_section.button_text.choosePlan';

    return (
      <Button
        aria-label={`
          ${retrieveContentfulData<string>(buttonLabelField)}
          ${plan.carrierName}
          ${plan.planMarketingName}
        `}
        size="small"
        stretch
        buttonType={isSelected ? 'secondary' : 'primary'}
        onClick={() => (isSelected ? deselectPlan() : choosePlan(plan.recommendation))}
        iconRight={isSelected ? 'X' : null}
        iconLeft={!isSelected ? 'PlusCircle' : null}
        data-testid={`choose-plan-button-${plan.planId}`} // Unique test ID per plan
      >
        <Text field={buttonLabelField} />
      </Button>
    );
  };

  return (
    <CompareTableRow
      asterisk={!hideAsterikIfCompareDrawer}
      columnOne={plans[0] ? renderChooseButton(plans[0]) : null}
      columnTwo={plans[1] && renderChooseButton(plans[1])}
      columnThree={plans[2] && renderChooseButton(plans[2])}
      size="small"
      keyHint={`choose-${selectedPlan.planId}`}
    />
  );
};
